export const shop = {
  contact_name: "Bv RSVP Test Account",
  contact_href: "https://line.me/R/ti/p/@476kcvih",
  liff_id: {
    _full: "1657272260-jK5zK0zB",
    compact: "1657272260-Jj6PDdPK",
    full: "1657272252-wljYQdYG",
    tall: "1657272260-YNkWwAW4",
  },
  settings: {
    delivery_fee: { seven: 60, family: 60, home: 80, maxfree: null },
  },
};

export const shuffle = (array) =>
  array
    .map((value) => ({ value, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ value }) => value);

export const liff = {
  error: "",
  ready: true,
  init: async () => {},
  openWindow: async () => {},
  shareTargetPicker: async () => {},
  getProfile: async () => {
    return {
      userId: "Uf65f9714a36288e8d4c9bfe3430e352b",
      displayName: "黃卷 Juan",
      statusMessage: "じゅえん",
      pictureUrl:
        "https://profile.line-scdn.net/0hDLs-SM7JG2NeVDCtltNlHC4EGAl9JUJxcDRVBWJWTAZgNloycTdVBmNSQVQxbVticjVSAG5QElRSR2wFQALnV1lkRVRnYl82cjNThQ",
    };
  },
  getAccessToken: () =>
    "eyJhbGciOiJIUzI1NiJ9.CF2Z0ki03a8hi9AYjtBXFy95tBAsbhch5WwYDqtSDPXpYtSk4wRehKAP366NhXYTdiv9sWGUAA-By8QenX244snSTjT23s5_IuR53h0rx7w1xQr_zIJ2zTxCp7RrdAtyWc6nlYMeq-sJsMX21955SgxFWhmVbhc_F-KzG3teC-o.yKVyW9LOEUSD3_6EFzraEEU79nMJmaWBTnSc-ID4ngg",
  isLoggedIn: () => true,
  isInClient: () => false,
};
